// extracted by mini-css-extract-plugin
module.exports = {"main-component":"marketPulseSurvey_main-component__2a-T4"};